import React from 'react'
import { Avatar, Box, Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { Ranking } from "model/Ranking";
import { useNavigate } from 'react-router';

type Props = {
  ranking: Ranking
}
export default function RankingTable(props: Props) {

  const navigate = useNavigate()

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>順位</TableCell>
            <TableCell>ユーザー</TableCell>
            <TableCell>レート</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.ranking.users.map((user, i) => (
            <React.Fragment key={user.uuid}>
              <TableRow>
                <TableCell>{user.rank}位</TableCell>
                <TableCell>
                  <Box sx={{
                    display: 'flex', flexDirection: 'row', alignItems: 'center'
                  }}>
                    <Avatar
                      variant='rounded'
                      src={user.profile_image_url}
                      sx={{mr: 0.5}}
                    />
                    <Link
                      onClick={() => navigate(`/mypage?id=${user.uuid}`)}
                      sx={{textDecoration: 'none', cursor: 'pointer'}}
                    >
                      {user.name}
                    </Link>
                  </Box>
                </TableCell>
                <TableCell>{user.rate}</TableCell>
              </TableRow>
              </React.Fragment>
            ))
          }
        </TableBody>
      </Table>
    </TableContainer>
  )
}